import styled from "styled-components";

export const Styles = styled.div`
  .phone-input-control {
    width: 100%;
    direction: ltr;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .phone-country-select {
    height: 40px;
    border-radius: 5px;
    padding: 0;
    padding-inline-start: 0.5rem;
    padding-inline-end: 0.4rem;
    border: 1px solid #e0e0e0;
    background-color: white;
    color: var(--input-font-color);
    min-width: 55px;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;

    &:hover,
    &:focus {
      border-color: var(--main-color);
      outline: 0;
    }
  }

  .phone-number-input {
    width: 100%;
    height: 40px;
    border-radius: 5px;
    padding: 0.375rem 0.75rem;
    direction: ltr;
    text-align: left;
    background-color: white;
    color: var(--input-font-color);
    border: ${({ errorMessage, validateOnChange, borderColor }) =>
    errorMessage && validateOnChange
      ? "1px solid var(--danger)"
      : borderColor
        ? `1px solid ${borderColor}`
        : "1px solid #e0e0e0"};
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
  }

  .phone-number-input:hover {
    border-color: var(--main-color);
  }

  .phone-number-input:focus {
    outline: 0;
    box-shadow: none;
    border: ${({ errorMessage, validateOnChange, borderColor }) =>
    errorMessage && validateOnChange
      ? "1px solid var(--danger)"
      : borderColor
        ? `1px solid ${borderColor}`
        : "1px solid var(--main-color)"};
    box-shadow: 0 0 0 3px rgba(28, 55, 65, 0.1);
  }
`;
